export default "__VITE_ASSET__NKSZpSDR__"